// extracted by mini-css-extract-plugin
module.exports = {"textInput":"NewCompany_textInput__sXJvU","logo":"NewCompany_logo__1RsrN","activeCheckbox":"NewCompany_activeCheckbox__1HCr7"};